import React, { useEffect, useState } from "react";
import { Table, Spinner, Card, Form, Badge } from "react-bootstrap";
import Layout from "../../layout/Layout";
import {
  boruProfilDaily,
  getMachineSpeed,
} from "../../../api/uretim/boruProfilDaily";
import { useNavigate } from "react-router-dom";

const MACHINE_LIST = [
  { no: 1, label: "M1", title: "Makina 1" },
  { no: 2, label: "M2", title: "Makina 2" },
  { no: 3, label: "M3", title: "Makina 3" },
  { no: 4, label: "M4", title: "Makina 4" },
];

const getArrayFromResponse = (response) => {
  const payload = response?.data ?? response;

  if (Array.isArray(payload)) {
    return payload;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  return [];
};

const getTodayForDateInput = () => {
  const formatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Europe/Istanbul",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  return formatter.format(new Date());
};

const getMachineNoFromSpeed = (speedItem) => {
  const directMachineNo = Number(
    speedItem?.makinaNo ??
      speedItem?.machineNo ??
      speedItem?.makinaAdi ??
      speedItem?.machineId
  );

  if (Number.isFinite(directMachineNo) && directMachineNo > 0) {
    return directMachineNo;
  }

  const machineName = String(
    speedItem?.name ??
      speedItem?.makina ??
      speedItem?.machineName ??
      speedItem?.label ??
      ""
  );

  const matchedNo = Number(machineName.match(/\d+/)?.[0]);

  return Number.isFinite(matchedNo) ? matchedNo : 0;
};

const getSpeedValue = (speedItem) => {
  const speed = Number(
    speedItem?.speed ??
      speedItem?.hiz ??
      speedItem?.value ??
      speedItem?.currentSpeed ??
      0
  );

  return Number.isFinite(speed) ? speed : 0;
};

const formatDateTR = (value) => {
  if (!value) return "-";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return date.toLocaleDateString("tr-TR", {
    timeZone: "Europe/Istanbul",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

const formatDateTimeTR = (value) => {
  if (!value) return "-";

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "-";
  }

  return date.toLocaleString("tr-TR", {
    timeZone: "Europe/Istanbul",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

function BoruProfilAnlik() {
  const [loading, setLoading] = useState(false);
  const [operatorList, setOperatorList] = useState([]);
  const [machineSpeeds, setMachineSpeeds] = useState([]);
  const [selectedDate, setSelectedDate] = useState(getTodayForDateInput);

  const navigate = useNavigate();

  // Üretim verilerini çekme
  const loadData = async (dateString) => {
    try {
      setLoading(true);

      const res = await boruProfilDaily(dateString);
      const records = getArrayFromResponse(res);

      setOperatorList(records);
    } catch (err) {
      console.error("Üretim verileri alınırken hata oluştu:", err);
      setOperatorList([]);
      alert("Veriler alınamadı!");
    } finally {
      setLoading(false);
    }
  };

  // Makina hızlarını çekme
  const loadSpeeds = async () => {
    try {
      const res = await getMachineSpeed();
      const speeds = getArrayFromResponse(res);

      setMachineSpeeds(speeds);
    } catch (err) {
      console.error("Hız verileri çekilirken hata oluştu:", err);
      setMachineSpeeds([]);
    }
  };

  useEffect(() => {
    loadData(selectedDate);

    const dataInterval = setInterval(() => {
      loadData(selectedDate);
    }, 30000);

    return () => clearInterval(dataInterval);
  }, [selectedDate]);

  useEffect(() => {
    loadSpeeds();

    const speedInterval = setInterval(() => {
      loadSpeeds();
    }, 10000);

    return () => clearInterval(speedInterval);
  }, []);

  const getDurusToplam = (duruslar, fiiliCalismaSuresi = 0) => {
    if (!duruslar || typeof duruslar !== "object") {
      return Number(fiiliCalismaSuresi || 0);
    }

    const durusToplam = Object.entries(duruslar)
      .filter(([key]) => !key.toLowerCase().includes("note"))
      .reduce((total, [, value]) => total + Number(value || 0), 0);

    return durusToplam + Number(fiiliCalismaSuresi || 0);
  };

  // 1 = GECE, 2 = GÜNDÜZ
  const getVardiyaTipi = (row) => {
    const vardiya = String(row?.vardiya ?? "").trim();

    if (vardiya === "2") {
      return "GUNDUZ";
    }

    if (vardiya === "1") {
      return "GECE";
    }

    return "GECIS";
  };

  const safeOperatorList = Array.isArray(operatorList) ? operatorList : [];
  const safeMachineSpeeds = Array.isArray(machineSpeeds) ? machineSpeeds : [];

  const getCurrentSpeed = (machineNo) => {
    const speedData = safeMachineSpeeds.find(
      (item) => getMachineNoFromSpeed(item) === machineNo
    );

    return getSpeedValue(speedData);
  };

  return (
    <Layout>
      <style>{`
        .blink-warning td {
          animation: blinkRow 0.8s infinite !important;
        }

        @keyframes blinkRow {
          0% {
            background-color: #fff3cd;
          }
          50% {
            background-color: #ffcb66;
          }
          100% {
            background-color: #fff3cd;
          }
        }

        .vardiya-gunduz td:first-child {
          border-left: 6px solid #3cb371;
        }

        .vardiya-gece td:first-child {
          border-left: 6px solid #4a90e2;
        }

        .vardiya-gecis td:first-child {
          border-left: 6px solid #adb5bd;
        }

        .blink-warning.vardiya-gunduz td:first-child,
        .blink-warning.vardiya-gece td:first-child,
        .blink-warning.vardiya-gecis td:first-child {
          border-left-color: #ffcb66;
        }

        .machine-speed-card {
          min-height: 120px;
          border-radius: 12px;
          transition: transform 0.2s ease, box-shadow 0.2s ease;
        }

        .machine-speed-card:hover {
          transform: translateY(-2px);
        }

        .machine-speed-card.active {
          background-color: #e8f5e9;
          border: 1px solid #a5d6a7;
        }

        .machine-speed-card.stopped {
          background-color: #ffebee;
          border: 1px solid #ef9a9a;
        }

        .machine-speed-value {
          font-size: 2rem;
          line-height: 1;
        }

        .table-responsive-wrapper {
          overflow-x: auto;
        }

        @media (max-width: 768px) {
          .page-header {
            align-items: stretch !important;
            flex-direction: column;
            gap: 12px;
          }

          h3.fw-bold {
            font-size: 1.3rem;
            text-align: center;
          }

          .card {
            padding: 8px !important;
          }

          h5.fw-bold {
            font-size: 1rem !important;
          }

          table {
            font-size: 0.75rem !important;
          }

          th,
          td {
            white-space: nowrap !important;
            padding: 4px 6px !important;
          }

          .machine-speed-card {
            min-height: 105px;
          }

          .machine-speed-value {
            font-size: 1.55rem;
          }
        }
      `}</style>

      {/* BAŞLIK VE TARİH */}
      <div className="page-header d-flex justify-content-between align-items-center mb-4">
        <h3 className="fw-bold mb-0">Anlık Üretim Takip</h3>

        <Form.Group>
          <Form.Control
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </Form.Group>
      </div>

      {/* M1 - M2 - M3 - M4 ANLIK HIZLARI */}
      <div className="row mb-4 g-3">
        {MACHINE_LIST.map((machine) => {
          const currentSpeed = getCurrentSpeed(machine.no);
          const isActive = currentSpeed > 0;

          return (
            <div className="col-6 col-lg-3" key={machine.no}>
              <Card
                className={`machine-speed-card shadow-sm ${
                  isActive ? "active" : "stopped"
                }`}
              >
                <Card.Body className="d-flex flex-column justify-content-center align-items-center text-center p-3">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <Badge bg={isActive ? "success" : "danger"}>
                      {isActive ? "ÇALIŞIYOR" : "DURUYOR"}
                    </Badge>

                    <span className="fw-bold text-muted">{machine.label}</span>
                  </div>

                  <h5 className="fw-bold mb-2">{machine.title}</h5>

                  <div
                    className="machine-speed-value fw-bold"
                    style={{
                      color: isActive ? "#2e7d32" : "#c62828",
                    }}
                  >
                    {currentSpeed}
                    <span
                      style={{
                        marginLeft: "6px",
                        fontSize: "0.95rem",
                        fontWeight: 500,
                        color: "#6c757d",
                      }}
                    >
                      m/dk
                    </span>
                  </div>
                </Card.Body>
              </Card>
            </div>
          );
        })}
      </div>

      {loading && safeOperatorList.length === 0 ? (
        <div className="text-center mt-4">
          <Spinner animation="border" />
        </div>
      ) : (
        <div className="row g-4">
          {MACHINE_LIST.map((machine) => {
            const makinaNo = machine.no;
            const currentSpeed = getCurrentSpeed(makinaNo);

            const rows = safeOperatorList.filter(
              (item) => Number(item?.makinaAdi) === makinaNo
            );

            const genelToplam = rows.reduce(
              (acc, row) => {
                const durusToplam = getDurusToplam(
                  row.duruslar,
                  row.fiiliCalismaSuresi
                );

                acc.paket += Number(row.bagAdeti || 0);
                acc.mamulKg += Number(row.mamulMiktariKg || 0);
                acc.toplamSure += Number(durusToplam || 0);

                return acc;
              },
              {
                paket: 0,
                mamulKg: 0,
                toplamSure: 0,
              }
            );

            return (
              <div className="col-12" key={makinaNo}>
                <Card className="p-2 shadow-sm">
                  <div className="d-flex justify-content-between align-items-center px-2 mt-2 mb-2">
                    <h5 className="fw-bold mb-0">{machine.title}</h5>

                    <Badge
                      bg={currentSpeed > 0 ? "success" : "danger"}
                      className="p-2"
                      style={{ fontSize: "0.9rem" }}
                    >
                      Anlık Hız: {currentSpeed} m/dk
                    </Badge>
                  </div>

                  <div className="table-responsive-wrapper">
                    <Table bordered hover responsive className="mb-0">
                      <thead>
                        <tr>
                          <th>İş Emri No</th>
                          <th>Form No</th>
                          <th>Firma</th>
                          <th>Malzeme Cinsi</th>
                          <th>Kalınlık</th>
                          <th>En 1</th>
                          <th>En 2</th>
                          <th>Boy</th>
                          <th>Paket Sayısı</th>
                          <th>Mamül Miktarı (Kg)</th>
                          <th>Toplam (Duruş + Fiili)</th>
                          <th>Operatör</th>
                          <th>Üretim Tarihi</th>
                          <th>Veri Girişi Tarihi</th>
                          <th>İşlem</th>
                        </tr>
                      </thead>

                      <tbody>
                        {rows.map((row) => {
                          const durusToplam = getDurusToplam(
                            row.duruslar,
                            row.fiiliCalismaSuresi
                          );

                          const vardiya = getVardiyaTipi(row);

                          const rowClassNames = [
                            row.messages?.length ? "blink-warning" : "",
                            vardiya === "GUNDUZ" ? "vardiya-gunduz" : "",
                            vardiya === "GECE" ? "vardiya-gece" : "",
                            vardiya === "GECIS" ? "vardiya-gecis" : "",
                          ]
                            .filter(Boolean)
                            .join(" ");

                          return (
                            <tr
                              key={row._id}
                              className={rowClassNames}
                              onClick={() =>
                                navigate(`/boruProfilDetay/${row._id}`)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <td>{row.isEmriNo ?? "-"}</td>
                              <td>{row.formNo ?? "-"}</td>
                              <td>{row.firma ?? "-"}</td>
                              <td>{row.malzemeCinsi ?? "-"}</td>
                              <td>{row.kalinlik ?? "-"}</td>
                              <td>{row.en1 ?? "-"}</td>
                              <td>{row.en2 ?? "-"}</td>
                              <td>{row.boy ?? "-"}</td>
                              <td>{row.bagAdeti ?? "-"}</td>
                              <td>{row.mamulMiktariKg ?? "-"}</td>
                              <td>{durusToplam}</td>
                              <td>{row.operator ?? "-"}</td>
                              <td>{formatDateTR(row.tarih)}</td>

                              {/* CREATEDAT = VERİ GİRİŞİ TARİHİ */}
                              <td>
                                {formatDateTimeTR(
                                  row.veriGirisiTarihi ?? row.createdAt
                                )}
                              </td>

                              <td
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(`/boruProfilDetay/${row._id}`);
                                }}
                                style={{ textAlign: "center" }}
                              >
                                <button className="btn btn-sm btn-primary">
                                  Detay
                                </button>
                              </td>
                            </tr>
                          );
                        })}

                        {rows.length > 0 && (
                          <tr
                            style={{
                              fontWeight: 800,
                              background: "#f1f3f5",
                              borderTop: "3px solid #adb5bd",
                            }}
                          >
                            <td colSpan={8} style={{ textAlign: "right" }}>
                              GENEL TOPLAM
                            </td>
                            <td>{genelToplam.paket}</td>
                            <td>{genelToplam.mamulKg}</td>
                            <td>{genelToplam.toplamSure}</td>
                            <td colSpan={4}></td>
                          </tr>
                        )}

                        {rows.length === 0 && (
                          <tr>
                            <td
                              colSpan={15}
                              className="text-center text-muted py-3"
                            >
                              Kayıt bulunamadı
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </Card>
              </div>
            );
          })}
        </div>
      )}
    </Layout>
  );
}

export default BoruProfilAnlik;
